interface CountryProvinceSelectorOptions {
  hideElement?: string;
}

export class CountryProvinceSelector {
  countryEl: HTMLSelectElement | null;
  provinceEl: HTMLInputElement | null;
  provinceContainer: HTMLElement | null;

  constructor(country_domid: string, province_domid: string, options: CountryProvinceSelectorOptions) {
    this.countryEl = document.getElementById(country_domid) as HTMLSelectElement | null;
    this.provinceEl = document.getElementById(province_domid) as HTMLInputElement | null;
    this.provinceContainer = document.getElementById(options.hideElement || province_domid) as HTMLElement | null;

    if (!this.countryEl || !this.provinceEl || !this.provinceContainer) {
      console.error("One or more elements not found");
      return;
    }

    countryProvinceAddListener(
      this.countryEl,
      "change",
      countryProvinceBind(this.countryHandler, this),
    );

    this.initCountry();
    this.initProvince();
  }

  initCountry() {
    const value = this.countryEl?.getAttribute("data-default");
    if (value) {
      countryProvinceSetSelectorByValue(this.countryEl, value);
      this.countryHandler();
    }
  }

  initProvince() {
    const value = this.provinceEl?.getAttribute("data-default");
    // @ts-expect-error: per convo with Adam Siegel, we need to address wether this is suppod to be an input or select at some point in the future. There is conflicting logic in the original JS implementation and the listing-form.ejs template.
    if (value && this.provinceEl && this.provinceEl.options.length > 0) {
      // @ts-expect-error: see above
      countryProvinceSetSelectorByValue(this.provinceEl, value);
    }
  }

  countryHandler(e?: Event) {
    const opt = this.countryEl?.options[this.countryEl.selectedIndex];
    const raw = opt?.getAttribute("data-provinces");
    const provinces = raw ? JSON.parse(raw) : [];
    const provinceInput = document.getElementById("rec-shipping-address-state") as HTMLInputElement | null;

    this.clearOptions(this.provinceEl);
    if (provinces.length === 0) {
      this.provinceContainer!.style.display = "none";
      if (provinceInput) {
        provinceInput.classList.remove("rec-required");
        provinceInput.setAttribute("aria-required", "false");
      }
    } else {
      this.setProvinceOptions(opt!.value);

      for (let i = 0; i < provinces.length; i++) {
        const option = document.createElement("option");
        option.value = provinces[i][0];
        option.innerHTML = provinces[i][1];
        this.provinceEl?.appendChild(option);
      }
    }
  }

  clearOptions(selector: HTMLInputElement | null) {
    while (selector?.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  }

  setOptions(selector: HTMLSelectElement | null, values: string[]) {
    for (let i = 0, count = values.length; i < count; i++) {
      const opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector?.appendChild(opt);
    }
  }

  setProvinceOptions(opt: string) {
    const provinceInput = document.getElementById("rec-shipping-address-state") as HTMLInputElement | null;
    if (!provinceInput) {
      console.error("Province input element not found");
      return;
    }

    if (opt === "Australia") {
      provinceInput.placeholder = "State/Territory";
      this.provinceContainer!.style.display = "";
      provinceInput.classList.add("rec-required");
      provinceInput.setAttribute("aria-required", "true");
    } else if (opt === "Spain" || opt === "Italy") {
      provinceInput.placeholder = "Province";
      this.provinceContainer!.style.display = "";
      provinceInput.classList.add("rec-required");
      provinceInput.setAttribute("aria-required", "true");
    } else if (opt === "United Kingdom") {
      provinceInput.setAttribute("aria-required", "false");
      provinceInput.classList.remove("rec-required");
      this.provinceContainer!.style.display = "none";
    } else if (opt === "Portugal") {
      provinceInput.placeholder = "Region";
      this.provinceContainer!.style.display = "";
      provinceInput.classList.add("rec-required");
      provinceInput.setAttribute("aria-required", "true");
    } else if (opt === "United States" || opt === "Canada") {
      provinceInput.placeholder = "State/Province";
      this.provinceContainer!.style.display = "";
      provinceInput.classList.add("rec-required");
      provinceInput.setAttribute("aria-required", "true");
    } else {
      provinceInput.placeholder = "Province";
      this.provinceContainer!.style.display = "";
      provinceInput.classList.add("rec-required");
      provinceInput.setAttribute("aria-required", "true");
    }
  }
}

// Helper functions
const countryProvinceBind = function (fn: Function, scope: any) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

const countryProvinceSetSelectorByValue = function (selector: HTMLSelectElement | null, value: string | null) {
  if (!selector) return;
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

const countryProvinceAddListener = function (target: EventTarget | null, eventName: string, callback: EventListenerOrEventListenerObject) {
  if (!target) return;
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : (target as any).attachEvent("on" + eventName, callback);
};